<template>
  <div class="asd20-picker" :class="{ 'asd20-picker--reversed': reversed }">
    <slot />
    <asd20-button
      class="picker-button"
      :label="buttonLabel"
      @click.native="open = true"
      icon="chevron"
      hideLabel
      size="sm"
      transparent
      :iconAngle="180"
      :reversed="reversed"
    />
    <asd20-modal
      :open="open"
      :title="modalLabel"
      dismissable
      @dismiss="dismiss"
      class="asd20-picker__modal"
      windowed
      :icon="modalIcon"
    >
      <asd20-viewport scrollable>
        <asd20-list-item
          v-if="organization.title !== 'Academy District 20'"
          class="district-link"
        >
          <a href="https://asd20.org">Academy District 20 Website</a>
        </asd20-list-item>
        <asd20-accordion :opened="true" label="Favorites">
          <transition-group name="fade" mode="in-out">
            <div class="list-item" v-for="item in trueItems" :key="item.id">
              <asd20-button :link="item.website">{{ item.label }}</asd20-button>
              <button @click="editFavorites(item.id)">
                <asd20-icon v-show="!item.value" :name="icon" size="md" />
                <asd20-icon
                  v-show="item.value"
                  :name="`${icon}-filled`"
                  size="md"
                />
              </button>
            </div>
          </transition-group>
        </asd20-accordion>
        <asd20-accordion
          v-for="(categoryItem, index) in itemsByCategoryOptions"
          :label="categoryItem.title + ' Schools'"
          :key="index"
        >
          <transition-group name="fade" mode="in-out">
            <div
              class="list-item"
              v-for="item in categoryItem.itemsSorted"
              :key="item.id"
            >
              <asd20-button :link="item.website">{{ item.label }}</asd20-button>
              <button @click="editFavorites(item.id)">
                <asd20-icon v-show="!item.value" :name="icon" size="md" />
                <asd20-icon
                  v-show="item.value"
                  :name="`${icon}-filled`"
                  size="md"
                />
              </button>
            </div>
          </transition-group>
        </asd20-accordion>
      </asd20-viewport>
    </asd20-modal>
  </div>
</template>

<script>
// import Asd20Checkbox from '../../atoms/Asd20Checkbox'
import Asd20Modal from '../../molecules/Asd20Modal'
import Asd20Button from '../../atoms/Asd20Button'
import Asd20Icon from '../../atoms/Asd20Icon'
import Asd20Accordion from '../../molecules/Asd20Accordion'
import Asd20Viewport from '../../atoms/Asd20Viewport'
import Asd20ListItem from '../../molecules/Asd20ListItem'

// Functionality
import { setCookie, getCookie } from '../../../helpers/cookieRecipe'
// import sortOrgsByLevel from '../../../helpers/sortOrgsByLevel'

export default {
  name: 'Asd20Picker',

  components: {
    // Asd20Checkbox,
    Asd20Modal,
    Asd20Button,
    Asd20Icon,
    Asd20Accordion,
    Asd20Viewport,
    Asd20ListItem,
  },
  props: {
    // All items of that type that exist
    items: {
      type: Array,
      default: () => [],
    },
    buttonLabel: {
      type: String,
      default: 'Choose a school',
    },
    modalLabel: {
      type: String,
      default: 'Modal',
    },
    modalIcon: {
      type: String,
      default: 'school',
    },
    icon: {
      type: String,
      default: 'star',
    },
    // categorized items become options to favorite
    itemsByCategory: {
      type: Array,
      default: () => [],
    },
    cookieLabel: {
      type: String,
      default: '',
      required: true,
    },
    reversed: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      favoritesById: [],
      favoritesEdited: [],
      open: false,
    }
  },
  mounted: function() {
    this.$nextTick(this.getClientCookie(), this.mapFavorites())
  },
  computed: {
    trueItems() {
      return this.favoritesEdited
        .filter(o => o.value === true)
        .sort((a, b) => {
          if (a.label < b.label) return -1
          if (a.label > b.label) return 1
          return 0
        })
    },
    // get all items from itemsByCategory map them to exclude false values from  favoritesEdited
    itemsByCategoryOptions() {
      const favoritesFalse = this.favoritesEdited.filter(i => i.value === false)
      return this.itemsByCategory.map(i => ({
        title: i.title,
        itemsSorted: favoritesFalse
          .filter(f => {
            let oldItems = i.itemsSorted.map(i => i.id)
            return oldItems.includes(f.id)
          })
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0)),
      }))
    },
    trueItemsById() {
      return this.trueItems.map(o => o.id)
    },
  },
  methods: {
    catchFavorites() {
      // this.saveFavorites()
    },
    editFavorites(id) {
      const editedFavorite = this.favoritesEdited.find(o => o.id === id)
      editedFavorite.value = !editedFavorite.value
    },
    mapFavorites() {
      const scrubItems = [
        ...new Set(
          this.items.map(o => ({
            ...o,
            // id: o.id,
            label: o.title,
            value: this.favoritesById
              ? this.favoritesById.includes(o.id)
              : false,
            // website: o.website,
            // educationLevels: o.educationLevels,
          }))
        ),
      ]
      this.favoritesEdited = scrubItems
    },
    mapItemsByCategory() {
      this.itemsByCategory.map(i => ({
        i,
      }))
    },
    dismiss() {
      this.open = false
      this.saveFavorites()
    },
    saveFavorites() {
      setCookie(this.cookieLabel, this.trueItemsById)
    },
    getClientCookie() {
      this.favoritesById = getCookie(this.cookieLabel)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';

.asd20-picker {
  position: relative;
  display: flex;
  align-items: center;
  .picker-button {
    // margin: space(0.1) space(0);
  }
  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    a {
      font-size: 1rem;
      text-align: left;
      color: var(--color__secondary-s30);
      text-decoration: none;
      display: flex;
      font-family: var(--website-typography__font-family-body);
      font-weight: 300;
      font-size: 0.85rem !important;
      flex-shrink: 1;
      background: transparent;
      // padding: 0 space(1);
      // flex-grow: 1;
    }

    button {
      appearance: none;
      border: 0;
      padding: 0.125rem;
      margin: 0.125rem 0;
      background: transparent;
      border-left: 1px solid rgba(0, 0, 0, 0.125);
    }
  }
  .list-item:hover {
    background: rgba(235, 235, 235, 0.8);
  }
  .asd20-button {
    position: relative;
    margin-left: space(0.5);
    padding: space(0.5) space(0.5);
    // &::before {
    //   content: '';
    //   position: absolute;
    //   width: 1px;
    //   left: space(-0.125);
    //   top: 0;
    //   bottom: 0;
    //   background: rgba(0, 0, 0, 0.125);
    // }
  }
  &--reversed {
    color: white;
    --line-color: white;
    &::v-deep .asd20-button {
      &::before {
        background: rgba(255, 255, 255, 0.25);
      }
    }
    &::v-deep .asd20-button--reversed {
      .asd20-icon {
        color: white;
        --line-color: white;
      }
    }
  }
}

.asd20-picker__modal {
  border-bottom: 2px solid rgba(235, 235, 235, 0.8);
  .district-link {
    margin-left: space(0.5) !important;
    font-weight: bold;
    font-size: 1rem;
    font-family: var(--website-typography__font-family-body) !important;

    a {
      color: var(--website-page__title-color);
      text-decoration: none;
    }
  }
  height: min-content;
  &::v-deep h2 {
    font-size: 1.15rem;
    margin: space(0.5) 0;
  }
  &::v-deep .asd20-accordion__header h3 {
    font-family: var(--website-typography__font-family-body) !important;
  }
  &::v-deep .asd20-accordion__content {
    padding: 0;
  }
  // &::v-deep .asd20-checkbox {
  //   margin-left: space(1);
  //   width: auto;
  // }
}

@media (min-width: 1024px) {
  .asd20-picker {
    .picker-button {
      margin: space(0.75);
      padding: space(0.25) !important;
      border: 1px solid #fff;
      border-radius: 50%;
    }
  }
  .asd20-picker__modal {
    &::v-deep .asd20-modal {
      width: 40vw;
      min-width: 400px;
      flex-grow: 0;
      height: min-content;
      max-height: 80vh;
    }
    height: auto;
  }
}
</style>